import { render, staticRenderFns } from "./Assinatura.vue?vue&type=template&id=7eb3c83e&scoped=true&"
import script from "./Assinatura.vue?vue&type=script&lang=js&"
export * from "./Assinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb3c83e",
  null
  
)

export default component.exports